











import { Component, Prop, Vue } from 'vue-property-decorator';

export interface VListGroupItem {
  [key: string]: string|number|null|undefined;
}

@Component
export default class VListGroup extends Vue {
  @Prop() readonly items!: Array<VListGroupItem>;
  @Prop({ default: false }) readonly ordered? : boolean;
  @Prop({ default: false }) readonly selectable? : boolean;
  @Prop() readonly isHighlighted? : Function;
  @Prop() readonly isOver? : Function;

  overed: VListGroupItem|undefined = {};

  select(item: VListGroupItem, index: number) {
    if (!this.selectable) {
      return;
    }

    this.$emit('selected', item, index);
  }

  itemClass(item: VListGroupItem) {
    const over = (this.overed && this.overed === item) || (this.isOver && this.isOver(item));

    return {
      'list-group-item--selectable': this.selectable,
      'list-group-item--highlighted': this.isHighlighted && this.isHighlighted(item),
      'list-group-item--over': over
    };
  }

  onStartOver(item: VListGroupItem) {
    this.overed = item;
    this.$emit('over', item);
  }

  // eslint-disable-next-line
  onEndOver(item: VListGroupItem) {
    this.overed = undefined;
    this.$emit('over', undefined);
  }
}
